import { Handle, Position } from '@xyflow/react'
import cloudLogo from '@/assets/hivemq-cloud-vert.png'
import controlPlaneLogo from '@/assets/control-panel.png'
import { Box, Flex, Text, IconButton, VStack } from '@chakra-ui/react'

function handleCCClick() {
  window.open('https://app.hivemq.com', '_blank', 'noreferrer')
}

function CloudNodeBi() {
  return (
    <Box
      bg="brand.solid"
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.700"
      p={3}
      minW="200px"
      boxShadow="md"
    >
      {/* Left handles */}
      <Handle id="a" type="target" position={Position.Left} />
      <Handle type="source" position={Position.Left} id="left" />

      {/* Right handles */}
      <Handle id="b" type="target" position={Position.Right} />
      <Handle type="source" position={Position.Right} />

      <Flex gap={3} align="stretch">
        {/* Left column - Features */}
        <VStack align="start" gap={0.5} flex="none" justify="center">
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Security
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Bridge
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            API
          </Text>
        </VStack>

        {/* Center column - Logo and Control Panel */}
        <VStack flex="1" gap={1}>
          <a href={import.meta.env.VITE_CLOUD_CC_ADDRESS} target="_blank" rel="noreferrer">
            <img
              src={cloudLogo}
              alt="HiveMQ Cloud"
              style={{ height: '50px', objectFit: 'contain' }}
            />
          </a>
          <IconButton
            aria-label="Open Cloud Console"
            size="xs"
            variant="ghost"
            onClick={handleCCClick}
            _hover={{ bg: 'whiteAlpha.400' }}
          >
            <img
              src={controlPlaneLogo}
              alt="Control Panel"
              style={{ height: '16px', width: '16px' }}
            />
          </IconButton>
        </VStack>

        {/* Right column - Features */}
        <VStack align="end" gap={0.5} flex="none" justify="center">
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Streaming
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Database
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Logs
          </Text>
        </VStack>
      </Flex>
    </Box>
  )
}

export default CloudNodeBi
